<script setup>
import { AlertDialogTitle } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <AlertDialogTitle
    :class="
      cn('text-foreground text-base font-medium leading-none', props.class)
    "
  >
    <slot />
  </AlertDialogTitle>
</template>
